import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { logger } from '@sheerid/jslib';
import './Tooltip.scss';

interface TooltipProps {
    labeledByFieldId: string;
}

interface TooltipWorkState {
    tooltipIsOpen: boolean;
}

export class TooltipComponent extends React.Component<TooltipProps, TooltipWorkState> {
    constructor(props: any) {
        super(props);
        this.state = {
            tooltipIsOpen: false,
        };
        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
    }

    showTooltip() {
        this.setState({
            tooltipIsOpen: true,
        });
    }

    hideTooltip() {
        this.setState({
            tooltipIsOpen: false,
        });
    }

    handleOnClick(tooltipIsOpen: boolean) {
        if (tooltipIsOpen) {
            this.hideTooltip();
        } else {
            this.showTooltip();
        }
    }

    public render() {
        return(
            <div
                className="sid-form-tooltip"
                onMouseEnter={this.showTooltip}
                onMouseLeave={this.hideTooltip}
            >
                <a
                    href="javascript:;"
                    className="sid-form-tooltip-link"
                    onFocus={this.showTooltip}
                    onBlur={this.hideTooltip}
                    onClick={() => this.handleOnClick(this.state.tooltipIsOpen)}
                    aria-labelledby={`${this.props.labeledByFieldId}-tooltip`}
                    aria-describedby={`${this.props.labeledByFieldId}-tooltip`}
                >
                    <i className="fa fa-question-circle-o"></i>
                </a>
                {
                    this.state.tooltipIsOpen ?
                        <div className="sid-form-tooltip__container">
                            <div className="sid-form-tooltip__caret" />
                            <div id={`${this.props.labeledByFieldId}-tooltip`} role="tooltip" className="sid-form-tooltip__tooltip">

                                    <div className="sid-form-tooltip__text sid-form-tooltip__content">
                                        <div className="sid-tooltip-top">
                                            <FormattedHTMLMessage
                                                id={`${this.props.labeledByFieldId}.tooltipTextTop`}
                                                defaultMessage={'Registered Dependent = A dependent of a sponsoring active duty or retiree who is registered with the US military.'}
                                            />
                                        </div>
                                    </div>
                                    <div className="sid-form-tooltip__text sid-form-tooltip__content-bottom">
                                        <div className="sid-tooltip-bottom">
                                            <FormattedHTMLMessage
                                                id={`${this.props.labeledByFieldId}.tooltipTextBottom`}
                                                defaultMessage={' '}
                                            />
                                        </div>
                                    </div>
                            </div>
                        </div>
                        :
                        null
                }
            </div>
        );
    }
}
